import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import DropzoneInput from './DropzoneInput';
import {
  IMAGE_AND_PDF_FILE_TYPES,
  formatAcceptedExtensions,
} from './acceptedFileTypes';
import PaperClip from '../../../images/global/paper-clip.svg';

const TO_MEGABYTES = 2 ** 20;

const buttonStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '38px',
  height: '38px',
  boxShadow: '0 3px 20px 0 rgba(25, 51, 106, 0.15)',
  borderRadius: '50%',
  backgroundColor: '#ffffff',
  cursor: 'pointer',
};

function FileUpload({
  label = undefined,
  value = [],
  onChange,
  error = null,
  style = {},
  multiple = false,
  maxSize = 2,
  onDropRejected = () => {},
  onDropAccepted = () => {},
  accept = IMAGE_AND_PDF_FILE_TYPES,
}) {
  const files = Array.isArray(value) ? value : [];
  const filenames = files.map(file => (
    <p
      style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        marginBottom: '0px',
      }}
      key={file.name}
    >
      {file.name}
    </p>
  ));

  return (
    <div style={{ marginBottom: '50px', position: 'relative', ...style }}>
      {label && <h3>{label}</h3>}
      <p className="onboarding-sub-label" style={{ marginBottom: '20px' }}>
        <FormattedMessage
          defaultMessage="{extensions} types allowed. Max file size is {maxSize} MB"
          values={{
            extensions: formatAcceptedExtensions(accept),
            maxSize,
          }}
        />
      </p>
      <DropzoneInput
        accept={accept}
        component={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={buttonStyle}>
              <PaperClip />
            </div>
            <div
              style={{
                maxWidth: '300px',
                whiteSpace: 'nowrap',
                marginLeft: '20px',
              }}
            >
              {filenames.length === 0 ? (
                <>
                  {multiple ? (
                    <FormattedMessage defaultMessage="Choose Files" />
                  ) : (
                    <FormattedMessage defaultMessage="Choose File" />
                  )}
                  <div
                    style={{
                      fontSize: '0.75em',
                      color: '#aaa',
                      marginTop: '2px',
                    }}
                  >
                    <FormattedMessage defaultMessage="or drag & drop" />
                  </div>
                </>
              ) : (
                filenames
              )}
            </div>
          </div>
        }
        multiple={multiple}
        onChange={onChange}
        maxSize={maxSize * TO_MEGABYTES}
        onDropRejected={onDropRejected}
        onDropAccepted={onDropAccepted}
      />
      {error && (
        <span
          className="error-text"
          style={{ position: 'absolute', bottom: '-25px' }}
        >
          {error}
        </span>
      )}
    </div>
  );
}

FileUpload.propTypes = {
  label: PropTypes.node,
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.node,
  style: PropTypes.object,
  multiple: PropTypes.bool,
  maxSize: PropTypes.number,
  onDropRejected: PropTypes.func,
  onDropAccepted: PropTypes.func,
  accept: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
};

export default FileUpload;
